import { SxProps, Theme } from '@mui/material';

/** Column wrapper for the login page: content grows to fill the viewport
 * (matching the original full-bleed layout) with the footer directly after
 * it, and the whole page scrolls naturally if content ever exceeds the
 * viewport height. */
export const pageWithFooterSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
};

/** The existing background-image + form row, now a flex child instead of
 * the outer element — `position: relative` keeps the absolutely-positioned
 * form panel anchored the same way it was before the footer was added. */
export const loginContentRowSx: SxProps<Theme> = {
    display: 'flex',
    flex: '1 1 auto',
    position: 'relative',
    overflow: 'hidden',
};
